import { useEffect, useRef, useState } from 'react'

// Every season in one scroll, one section each ([data-season]), under a row
// of chips that stays at the top: which season is in view, and a jump to
// one. `first` is the season shown before any scrolling.
const scrollerOf = (el) => {
  let n = el && el.parentElement
  while (n && n !== document.body) {
    const o = window.getComputedStyle(n).overflowY
    if (o === 'auto' || o === 'scroll') return n
    n = n.parentElement
  }
  return null
}

export const useSeasonJump = (first) => {
  const barRef = useRef(null)
  const [active, setActive] = useState(first)

  useEffect(() => {
    const bar = barRef.current
    const box = scrollerOf(bar)
    if (!box) return undefined
    const onScroll = () => {
      const edge = box.getBoundingClientRect().top + bar.offsetHeight + 16
      let id = null
      box.querySelectorAll('[data-season]').forEach((s) => { if (s.getBoundingClientRect().top <= edge) id = s.dataset.season })
      setActive(id || first)
    }
    box.addEventListener('scroll', onScroll, { passive: true })
    return () => box.removeEventListener('scroll', onScroll)
  }, [first])

  // The chip for the season in view stays in sight along the row
  useEffect(() => {
    const bar = barRef.current
    const chip = bar && bar.querySelector(`[data-chip="${active}"]`)
    if (chip) bar.scrollTo({ left: chip.offsetLeft - bar.offsetWidth / 2 + chip.offsetWidth / 2, behavior: 'smooth' })
  }, [active])

  const jump = (id) => {
    const bar = barRef.current
    const box = scrollerOf(bar)
    const section = box && box.querySelector(`[data-season="${id}"]`)
    if (!section) return
    const top = section.getBoundingClientRect().top - box.getBoundingClientRect().top + box.scrollTop - bar.offsetHeight - 8
    const still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches
    box.scrollTo({ top, behavior: still ? 'auto' : 'smooth' })
    setActive(id)
  }

  return { barRef, active, jump }
}
